import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS } from "./api-base"
import { getESGReqHeader } from "./tool-service";

// 查詢註冊帳戶清單
export const queryFeUsersList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1010101'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1010101")}`, method: 'post', data: ReqBody })
}

// 查詢單筆帳戶詳情
export const queryFeUsersInfo = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1010102'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1010102")}`, method: 'post', data: ReqBody })
}

//更新帳戶資訊 before
export const B1010103Before = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1010103'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1010103",true)}`, method: 'post', data: ReqBody })
}

//更新帳戶資訊 
export const updateFeUsersInfo = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1010103'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1010103")}`, method: 'post', data: ReqBody })
}

// 刪除單筆帳戶詳情 (作廢)
export const suspendFeUsersInfo = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1010104'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1010104")}`, method: 'post', data: ReqBody })
}

// 查詢公司角色清單
export const queryFeRolesList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1000002'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1000002")}`, method: 'post', data: ReqBody })
}

export const unlockUserAccount = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B1010105'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B1010105")}`, method: 'post', data: ReqBody })
}

//更新使用者資訊 
export const updateFeUsers2Info = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1020301 '),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1020301 ")}`, method: 'post', data: ReqBody })
}

